export default import.meta.ROLLDOWN_FILE_URL_l1Sd_Cajay5XdkGmaL$idw